module.exports = __webpack_public_path__ + "static/media/A6.9601ff95.png";